// libs
import React from 'react'
import { Redirect } from 'react-router-dom'

// interfaces / constants
import { FRONTEND_NOT_FOUND_PATH } from 'src/constants/urls'

// components
import LoadingSpinnerWrapper from 'src/components/loading_spinner/loading_spinner_wrapper'
import ProfileListWrapper from 'src/containers/smart_components/list_wrapper/profile_list_wrapper'

// helpers
import { FollowerListQuery } from '@lopo-tech/lopo-api'
import { ProfilesList } from 'src/components/profiles_list/profiles_list'
import { textResources } from 'src/lang/de'
import { createBemBlock } from 'src/utils/bem_helper/bem_helper'
import './profile_followers.scss'

const labels = textResources.follow
const cls = createBemBlock('profile_followers')
const noFollowersCls = cls('no-followers')

interface IProps {
  currentPage: number;
  getNextPage: () => void;
  isLoading: boolean;
  profileWithFollowers: FollowerListQuery['profile'];
}

const ProfileFollowers: React.FC<IProps> = ({
  currentPage,
  getNextPage,
  isLoading,
  profileWithFollowers
}) => {
  if ((!isLoading && !profileWithFollowers) || (profileWithFollowers && profileWithFollowers.__typename === 'PrivateProfile')) {
    return <Redirect to={FRONTEND_NOT_FOUND_PATH} />
  }

  return (
    <LoadingSpinnerWrapper isLoading={isLoading}>
      <ProfileListWrapper
        currentPage={currentPage}
        getNextPage={getNextPage}
        initialLoad={false}
      >
        {!isLoading && !profileWithFollowers?.followers?.items.length
          ? (
            <div className={noFollowersCls}>
              <p>{labels.noFollowersTitle}</p>
              <p>{labels.noFollowersMessage}</p>
            </div>
          )
          : (
            <ProfilesList profiles={profileWithFollowers?.followers?.items ?? []} />
          )}
      </ProfileListWrapper>
    </LoadingSpinnerWrapper>
  )
}

ProfileFollowers.displayName = 'ProfileFollowers'

export default ProfileFollowers
